import { Resp } from '~/plugins/_helpers'

export const CommonMixin = {
  methods: {
    iosCursore() {
      if (Resp.isIos || Resp.isIosChrome) {
        document.documentElement.style.cursor = 'pointer'
      }
    },
    isSafary() {
      if (Resp.isSafari) {
        document.documentElement.classList.add('isSafariWebBrowser')
      }
    },
    isIE() {
      if (Resp.isIE) {
        document.documentElement.classList.add('isIEWebBrowser')
      }
    },
    detectMouse() {
      function detecter(e) {
        if (e.type == 'mousemove') {
          document.body.classList.add('no-touch')
          window.removeEventListener('mousemove', detecter)
        }
        if (e.type == 'touchend') {
          document.body.classList.remove('no-touch')
          window.removeEventListener('mousemove', detecter)
          window.removeEventListener('touchend', detecter)
        }
      }
      window.addEventListener('mousemove', detecter)
      window.addEventListener('touchend', detecter)
    }
  }
}



// WEBPACK FOOTER //
// ./mixins/Common.js